/**
 * Corpo recolhível: altura por `grid-template-rows 0fr → 1fr` (280 ms ao
 * abrir, 200 ms ao fechar) e conteúdo com fade + 4 px. Fechado fica `inert`
 * (fora do Tab e do leitor de tela) sem desmontar — reabrir é instantâneo.
 */
import React from "react";

export default function Recolhivel({ aberto, id, children }) {
  return (
    <div className="cl-recolhivel" data-aberto={aberto} id={id}>
      <div inert={!aberto} aria-hidden={aberto ? undefined : true}>
        {children}
      </div>
    </div>
  );
}
